import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Wrapper = styled(Grid)(() => ({
  "& > div:nth-child(1)": {
    marginBottom: "20px",
  },
}));

export const ContainerViewWrapper = styled("div")(() => ({
  marginTop: "24px",
  marginBottom: "24px",
}));
